import { Form } from "react-bootstrap";
import { useEffect, useRef } from "react";
import cn from "../../../../../Utils/class-names.utils";
import SelectArrowIcon from "../../../../icons/select-arrow.icon";
import { HGHighlightText } from "../../../../App/App";
import useToggleRow from "../../../../../hooks/toggle-row.hook";

interface PracticeType {
  practiceTypeId: string | number;
  practiceTypeName: string;
  practiceTypeIcon?: string;
  isSelected: boolean;
}

interface Practice {
  practiceId: string | number;
  practiceName: string;
  practiceTypes: PracticeType[];
}

interface PracticeTypeRowProps {
  practice: Practice;
  search?: string;
  onPracticeTypeSelectionChange?: (practiceId: string | number, practiceTypeId: string | number, isSelected: boolean) => void;
  isView?: boolean;
}

const PracticeTypeRow = ({ practice, search, onPracticeTypeSelectionChange, isView = false }: PracticeTypeRowProps) => {
  const rowRef = useRef<HTMLDivElement>(null);
  const { panelRef, toggleRow, isOpenFixed } = useToggleRow({ rowRef, parentId: "practice-types-list" as any, defaultOpen: true, multiple: true });

  return (
    <div ref={rowRef} className="point">
      <div className="d-flex align-items-center gap-4" style={{ padding: "4px 8px", cursor: "pointer" }} onClick={() => toggleRow()}>
        <div className={cn("d-flex align-items-center", {
          "opacity-0": !practice.practiceTypes.length,
        })} style={{ height: "16px", width: "16px", justifyContent: "center" }}>
          <SelectArrowIcon width="12px" className={isOpenFixed ? 'rotate180' : ''} />
        </div>
        <span 
          className="f-14"
          dangerouslySetInnerHTML={{ __html: HGHighlightText(practice.practiceName, search || '') }}
        />
      </div>
      <div className="panel" ref={panelRef}>
        <div className={cn("d-flex flex-column gap-2")} style={{ paddingLeft: "20px" }}>
          {practice.practiceTypes.map(practiceType => (
            <div key={practiceType.practiceTypeId} className="d-flex align-items-center gap-16" style={{ padding: "4px 8px" }}>
              <Form.Group
                className={`fixed-checkbox blue-checkbox pointer-checkbox`}
                onClick={(e: any) => {
                  e.stopPropagation();
                }}
              >
                <Form.Check
                  id={`checkbox-${practiceType.practiceTypeId}`}
                  type="checkbox"
                  label=""
                  name={`checkbox`}
                  onChange={(e) => {
                    if (isView) return;
                    onPracticeTypeSelectionChange?.(practice.practiceId, practiceType.practiceTypeId, e.target.checked);
                  }}
                  checked={practiceType.isSelected}
                  disabled={isView}
                />
              </Form.Group>
              <div className="d-flex align-items-center gap-4">
                <label 
                  htmlFor={`checkbox-${practiceType.practiceTypeId}`}
                  className="f-14 m-0"
                  dangerouslySetInnerHTML={{ __html: HGHighlightText(practiceType.practiceTypeName, search || '') }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default PracticeTypeRow;

